<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <!--
    <div class="banner-block">
      
      <swiper :options="swiperOption">
        <swiper-slide v-for="(banner, index) in filteredBanners" :key="index">
          <img :src="baseUrl+ 'images/main-banner/' + banner" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    -->

    <section class="top_banner home_banner">
      <div class="middle_content img_default">
        <div>
          <p>
            <span class="img_default">全世界で使える海外Wi-Fi</span>
          </p>
          <h3>プランお申し込みページ</h3>
        </div>
      </div>
    </section>
    <section class="area_content">
      <h3 class="top_title">
        <span class="img_default">エリアを選択する</span>
      </h3>
      <ul class="area_list clearfix">
        <li v-for="(area) in areas" :key="area.id">
          <a :href="getAreaUrl(area.id)">
          <!--<a href @click="onSelectArea(area)">-->
            <div class="area_photo" :style="getBackgrounUrl(area.img_src)"></div>
            <div class="area_info">
              <h3 class="area_title">{{area.title}}</h3>
              <h4 class="area_sub_title">{{area.subtitle}}</h4>
            </div>
          </a>
        </li>
      </ul>
    </section>
    <JetfiCountryList></JetfiCountryList>
    <!--
    <section class="support_area_list">
      <h3 class="top_title_blue">対応国一覧</h3>
      <ul class="area_info">
        <li>
          <h4 class="area_title">◆ アジア</h4>
          <p class="info">
            中国、香港、マカオ、日本、台湾、韓国、シンガポール、マレーシア、インドネシア、フィリピン、タイ、ベトナム、カンボジア、ラオス、カザフスタン、モンゴル、インド、バングラデシュ、スリランカ、パキスタン、ネパール、ミャンマー 、アラブ首長国連邦、サウジアラビア、カタール、バーレーン、イスラエル、ヨルダン
            <br />※ モルディブ（ご利用する場合、お申込み後必ずサポートセンターにご連絡ください。）
          </p>
        </li>
        <li>
          <h4 class="area_title">◆ ヨーロッパ</h4>
          <p
            class="info"
          >イギリス、アイルランド、フランス、モナコ、ドイツ、スイス、リヒテンシュタイン、オーストリア、オランダ、ベルギー、ルクセンブルク、デンマーク、ノルウェー、スウェーデン、フィンランド、オーランド諸島、アイスランド、スペイン、ポルトガル、イタリア、バチカン、サンマリノ、チェコ、ハンガリー、ギリシャ、トルコ、ロシア、ポーランド、クロアチア、アルバニア、ブルガリア、キプロス、エストニア、リトアニア、ラトビア、マルタ共和国、ルーマニア、セルビア、スロベニア、スロバキア、ウクライナ</p>
        </li>
        <li>
          <h4 class="area_title">◆ 北アメリカ</h4>
          <p class="info">アメリカ合衆国（ハワイ、アラスカ、グアム、サイパン含む）、カナダ、メキシコ、プエルトリコ</p>
        </li>
        <li>
          <h4 class="area_title">◆ 南アメリカ</h4>
          <p
            class="info"
          >パナマ、コロンビア、ベネズエラ、ブラジル、アルゼンチン、チリ、ペルー、グアテマラ、ニカラグア、エルサルバドル共和国、コスタリカ、ボリビア、エクアドル、ウルグアイ、ドミニカ共和国</p>
        </li>
        <li>
          <h4 class="area_title">◆ オセアニア</h4>
          <p class="info">オーストラリア、ニュージーランド、フィジー</p>
        </li>
        <li>
          <h4 class="area_title">◆ アフリカ</h4>
          <p class="info">エジプト、ガーナ、ケニア、モロッコ、モーリシャス、ナイジェリア、チュニジア、タンザニア、南アフリカ共和国、ザンビア、アルジェリア、アンゴラ、西サハラ</p>
        </li>
      </ul>
    </section>
    -->
  </div>
</template>

<script>
import Vue from "vue";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import JetfiCountryList from "@/components/JetfiCountryList.vue";

export default {
  name: "JetfiAreas",
  props: {},
  data: function() {
    return {
      baseUrl: process.env.BASE_URL,
      baseImageUrl: process.env.VUE_APP_BASE_IMAGE_URL,
      storage_prefix: process.env.VUE_APP_STORAGE_PREFIX,
      banners: [
        process.env.VUE_APP_BANNER_1,
        process.env.VUE_APP_BANNER_2,
        process.env.VUE_APP_BANNER_3,
        process.env.VUE_APP_BANNER_4,
        process.env.VUE_APP_BANNER_5
      ],
      isLoading: false,
      fullPage: true,
      areas: [],
      errorMessage: "",
      isAreasLoaded: false,
      swiperOption: {
        paceBetween: 30,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  created: function() {
    console.log("[JetfiAreas] created", this.storage_prefix, this.banners);
    this.isAreasLoaded = this.$store.state.isAreasLoaded;
    this.errorMessage = this.$store.state.getAreasErrorMessage;
    this.areas = Vue.$sessionStorage.get("areas") || this.$store.state.areas;
  },
  mounted: function() {
    console.log("[JetfiAreas] mounted", this.$store.state.isAreasLoaded);
    this.initialize();
  },
  methods: {
    initialize() {
      console.log("[JetfiAreas] initialize");
      this.errorMessage = "";
      if (this.areas && this.areas.length === 0 && !this.isAreasLoaded) {
        this.getAreas();
      }
    },
    getAreas() {
      this.isLoading = true;
      this.$store
        .dispatch("getAreas", {
          params: {
            type: this.$router.currentRoute.query.t,
            short: true
          }
        })
        .then(() => {
          console.log("[JetfiAreas] store areas:", this.$store.state.areas);
          this.isAreasLoaded = this.$store.state.isAreasLoaded;
          this.errorMessage = this.$store.state.getAreasErrorMessage;
          this.areas = this.$store.state.areas;
          this.isLoading = false;
        });
    },
    getBackgrounUrl(img) {
      // console.log(area.img_src)
      // let imageUrl = "images/" + area.img_src;
      if (img) {
        let imageUrl = encodeURI(this.baseImageUrl + "/" + img);
        //console.log(imageUrl);
        return {
          "background-image": `url('${imageUrl}')`
        };
      } else {
        return {};
      }
    },
    getAreaUrl(id) {
      let param = Object.assign({}, this.$router.currentRoute.query); 
      // to prevent existed aid in url params
      param["aid"] = id;
      const { href } = this.$router.resolve({
        path: "countries",
        query: param
      });
      return href;
    },
    onSelectArea(area) {
      this.$store.dispatch("SetCurrentArea", area.id).then(() => {
        console.log(
          "[JetfiAreas] SetCurrentArea done:",
          this.$store.state.currentArea
        );
        this.$router.push({
          path: "countries",
          query: this.$router.currentRoute.query
        });
      });
    }
  },
  computed: {
    filteredBanners: function() {
      return this.banners.filter(function(banner) {
        return banner != null && banner != "";
      });
    }
  },
  components: {
    Loading,
    JetfiCountryList
  }
};
</script>

<style scoped>
.banner-block {
  width: 100%;
  height: 400px;
  position: relative;
}

.banner-block .swiper-container {
  width: 100%;
  height: 400px;
  position: static;
}

.banner-block .banner_title {
  width: 100%;
  position: absolute;
  top: 33%;
  font-family: "Noto Sans TC", sans-serif;
  z-index: 1;
  color: #fff;
  font-size: 40px;
  font-weight: bold;
  text-align: center;
  text-shadow: 0px 0px 15px rgba(0, 0, 0, 0.7);
}

/* .banner-block .swiper-slide {
  text-align: center;
  border-radius: 100%;
  color: #fff;
  font-size: 0.813rem;
  width: 2.813rem !important;
  height: 2.813rem;
  position: static;
} */
</style>
